import React, {useState, useEffect } from "react";
import { AppMenu, ActiveAppName, UserMenu } from '../../../mtska-frontend-app-component';
import { AppContext } from '../../contexts';
import Minimizer from "./Minimizer";

const Aside = ({onOpenLayout}) => {

    const { modules, logo, title } = React.useContext(AppContext);
    const [isOpen, setIsOpen] = useState();

    useEffect(() => {
        setIsOpen((localStorage.getItem('prefersAsideOpen') === 'true') ?? true);
        onOpenLayout();
    }, [])

    const [isMouseInside, setIsMouseInside] = useState(false);

    const handleIsOpen = () => {
        localStorage.setItem('prefersAsideOpen',!isOpen);
        setIsOpen(!isOpen);
        onOpenLayout();
    }

    const handleMouseEnter = () => {
        setIsMouseInside(true);
    }

    const handleMouseLeave = () => {
        setIsMouseInside(false);
    }

    return (
        <aside className={(isOpen) ? 'open' : 'closed'} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <ActiveAppName logo={logo} title={title}/>
            <AppMenu modules={modules}/>
            <UserMenu />

            <Minimizer onClick={handleIsOpen} visible={isMouseInside} open={isOpen}/>
        </aside>
    );
}

export default Aside;